//  POEdit.aspx
var PoEdit = (function (backOffice, $) {

    backOffice.PoEdit = (function () {
        var addItemModalId = "#addItemModal";
        var supplierCommentsId;
        var deliverToId;
        var rtsPoId;
        var portraitPdf;
        var multiSupplierEnabled;
        var hdnInheritPricingId;
        var poStatus;

        var registerEvents = function () {
                Sys.Application.add_load(function() {
                    var rtsPo = $find(rtsPoId);
                    var tab = rtsPo.get_selectedTab();

                    if (tab.get_value() === "tabAddItems") {
                        $('#tbxPLU').focus();
                        //required to set cursor in IE
                        $('#tbxPLU').select();
                    } else {
                        //required to start focus cycle from tabs in IE
                        $(tab.get_element()).find("a").focus();
                    }

                    $("#editPoForm").keypress(function (e) {
                        if ((e.keycode === 13 || e.which === 13)) {
                            e.preventDefault();
                        }
                    });
                });
            },

            checkAll = function (el) {
                const isAllChecked = $(el).is(":checked");
                $("[name ='check-item']").children().prop('checked', isAllChecked);
                return false;
            },

            initialise = function (options) {
                supplierCommentsId = options.supplierCommentsId;
                deliverToId = options.deliverToId;
                rtsPoId = options.rtsPoId;
                portraitPdf = options.portraitPdf;
                multiSupplierEnabled = options.multiSupplierEnabled;
                hdnInheritPricingId = options.hdnInheritPricingId;
                poStatus = options.poStatus;
                $.extend(backOffice.options, options);
                registerEvents();
            };

        var openAddItemModal = function () {

            $('#tbxPLU').val('');

            //register event after tab pos request
            $(addItemModalId).on("shown.bs.modal", function (e) { $(addItemModalId + " #fldItemQuantity").select(); });

            $(addItemModalId).modal("show");

            $(addItemModalId).keypress(function (e) {
                if ($(addItemModalId).hasClass("in") && (e.keycode === 13 || e.which === 13)) {
                    e.preventDefault();
                    $("#btnCreateItem").click();
                }
            });

            $("#ddlProductSelector").on("change", function (e) {
                var that = $(this),
                    identifier = that.val(),
                    items = that.closest(".modal-body").find("[data-product]");

                for (var i = 0; i < items.length; i++) {
                    var $item = $(items[i]);
                    if (identifier == "all") {
                        $item.closest(".hybrid-edit-form").show();
                    } else {
                        if ($item.attr("data-product") == identifier) {
                            $item.closest(".hybrid-edit-form").show();
                        } else {
                            $item.closest(".hybrid-edit-form").hide();
                        }
                    }
                }
            });
        };

        var hideAddItemModal = function () {
            //register event after tab pos request

            $(addItemModalId).modal('hide');
            $('#tbxPLU').focus();
        };

        var confirmAddItem = function () {
            if (validateAddItemForm()) {
                hideAddItemModal();

                return true;
            }

            return false;
        };

        var updateAddItemTotal = function (el) {
            var table = $(el).closest("table[data-product]");

            var qty = table.find("#fldItemQuantity").val();
            var supBuy = table.find("#fldItemSupplierBuy").val();

            var total = "";

            if (validateQuantity(qty) && validateSupplierBuy(supBuy)) {
                total = (qty * supBuy).toFixed(2);
            }

            table.find("#fldItemTotalPrice").text(total);
        };

        var validateAddItemForm = function () {
            var isValid = true;
            var prodTables = $(addItemModalId).find("table[data-product]");

            if (prodTables.length == 1) {
                var table = prodTables.first();

                var qty = table.find("#fldItemQuantity").val();
                var supBuy = table.find("#fldItemSupplierBuy").val();

                if (!validateQuantity(qty) || !validateSupplierBuy(supBuy)) {
                    isValid = false;
                }
            }
            else {
                var totals = prodTables
                    .find("#fldItemTotalPrice")
                    .filter(function (index, el) {
                        return el.innerText != "";
                    });

                if (totals.length == 0) {
                    alert("Please enter Quantity and Supplier Buy for at least one product");
                    isValid = false;
                }
            }

            return isValid;
        };

        var validateQuantity = function (quantity) {
            var isValid = true;

            if (quantity == null || quantity == "") {
                alert("Please enter Quantity");
                isValid = false;
            }
            else {                
                //whole number greater then 0
                var regEx = new RegExp("^([1-9]|[1-9][0-9]*)$");

                if (!regEx.test(quantity)) {
                    alert("Quantity must be a whole number greater than 0");
                    isValid = false;
                }
            }

            return isValid;
        };

        var validateSupplierBuy = function (supBuy) {
            var isValid = true;

            if (supBuy == null || supBuy == "") {
                alert("Please enter Supplier Buy");
                isValid = false;
            }
            else {
                //any decimal value and 0
                var regEx = new RegExp("^([0-9]+(?:[.][0-9]*)?|[.][0-9]+)$");

                if (!regEx.test(supBuy)) {
                    alert("Supplier Buy must be a positive number");
                    isValid = false;
                }
            }

            return isValid;
        };

        var openEditPOItemModal = function () {
            //register event after tab pos request
            $('#updatePOModal').on('shown.bs.modal', function (e) {
                $('#updatePOModal #fldQty').select();
            });

            $('#updatePOModal').modal('show');

            $("#updatePOModal").keypress(function (e) {
                if ($("#updatePOModal").hasClass("in") && (e.keycode === 13 || e.which === 13)) {
                    e.preventDefault();
                    $("#btnUpdateItem").click();
                }
            });
        };

        var hideEditPOItemModal = function () {
            //register event after tab pos request

            $("#updatePOModal").modal("hide");
            $('#tbxPLU').focus();
        };

        var hideClosePOModal = function () {
            $("#closePOModal").modal("hide");
        }

        var openClosePOModal = function () {
            $("#closePOModal").modal("show");
        }

        var hidePlaceOnBackOrderModal = function () {
            $("#placeOnBackOrderModal").modal("hide");
        }

        var showPlaceOnBackOrderModal = function () {
            $("#placeOnBackOrderModal").modal("show");
        }

        var hideSavePOModal = function () {
            $("#savePOModal").modal("hide");
        }

        var showSavePOModal = function () {
            if (!validatePo()) {
                return false;
            }

            if (multiSupplierEnabled && poStatus === POStatusEnum.Incomplete) {
                $("#savePOModal").modal("show");
                return false;
            }
            BackOffice.ToggleLoader(true);
            return true;
        }

        var setInheritPricing = function (value) {
            var hdnField = document.getElementById(hdnInheritPricingId);
            if (!hdnField) {
                return false;
            }
            hdnField.value = value.toString();
            hideSavePOModal();
            BackOffice.ToggleLoader(true);
            return true;
        }

        var showEmailPreview = function () {
            window.open('/DOTNET/Admin/Inventory/POMaint/POEmail.aspx?poid=' + $('#tbxPOID').val()
                + (!portraitPdf ? '&Barcode=true' : "&portrait=true")
                + '&templateFormat=' + $('#ddlPurchaseOrderTemplate :selected').val());
        };

        var showLinkedTransfers = function () {
            window.open('/DOTNET/Admin/Logistics/InternalTransferOrders/ReportITO.aspx?POID=' + $('#tbxPOID').val());
        };

        var showSOLinkedTransfers = function () {
            window.open('/DOTNET/Admin/Reports/SpecialOrdersReport.aspx?POID=' + $('#tbxPOID').val());
        };

        var printPO = function () {
            if ($("#ddlPurchaseOrderTemplate").val() === "Standard") {
                window.open('/Admin/Inventory/POMaint/POEmail.asp?POID=' + $('#tbxPOID').val() + '&FullURL=false'
                    + (!portraitPdf ? '&Barcode=true' : "&portrait=true"));
            }
            else {
                window.open('/DOTNET/Admin/Inventory/POMaint/POEmailPreview.aspx?POID=' + $('#tbxPOID').val() + '&Barcode=true');
            }
        };

        var validatePo = function(){

            if (!$("#ddlOutlet").val()) {
                alert("Please select an Outlet.");
                return false;
            }

            if (!$("#ddlSupplier").val()) {
                alert("Please select a Supplier.");
                return false;
            }

            if (BackOffice.ContainHtml($(supplierCommentsId).val())){
                alert("Please remove HTML code from Supplier Comment");
                return false;
            }

            if (BackOffice.ContainHtml($(deliverToId).val())){
                alert("Please remove HTML code from deliverTo");
                return false;
            }

            return true;
        };

        var productAttributeEnum = {
            Brand: 1,
            Season: 2,
            Size: 3,
            Colour: 4
        };

        var POStatusEnum = {
            Incomplete: 5
        };
        
        return $.extend(backOffice.PoEdit, {
            Init: initialise,
            CheckAll: checkAll,
            OpenAddItemModal: openAddItemModal,
            OpenEditPOItemModal: openEditPOItemModal,
            HideAddItemModal: hideAddItemModal,
            HideEditPOItemModal: hideEditPOItemModal,
            ConfirmAddItem: confirmAddItem,
            UpdateAddItemTotal: updateAddItemTotal,
            ShowEmailPreview: showEmailPreview,
            ShowLinkedTransfers: showLinkedTransfers,
            ShowSOLinkedTransfers: showSOLinkedTransfers,
            PrintPO: printPO,
            ValidatePo: validatePo,
            ProductAttributeEnum: productAttributeEnum,
            HideClosePOModal: hideClosePOModal,
            OpenClosePOModal: openClosePOModal,
            HidePlaceOnBackOrderModal: hidePlaceOnBackOrderModal,
            ShowPlaceOnBackOrderModal: showPlaceOnBackOrderModal,
            HideSavePOModal: hideSavePOModal,
            ShowSavePOModal: showSavePOModal,
            SetInheritPricing: setInheritPricing
        });
    })();

    //init sub-namespace
    InitCreateStyleModal(backOffice.PoEdit, $)
    InitCreateProductModal(backOffice.PoEdit, $);
    InitQuickReceiveModal(backOffice.PoEdit, $);

    return backOffice.PoEdit;
})(BackOffice || {}, jQuery);